import Button from "@mui/material/Button";
import { Stack, Radio, FormControlLabel, Checkbox } from "@mui/material";

import { FieldSelect } from "../../../../../components/Fields";

import "../../styles.css";

export default function PainelNervosCranianos({
  handleChangePanel,
  onSubmit,
  data,
  setData,
  simOuNaoOptions,
  presenteAusenteOptions,
  reflexoNauseosoOptions,
  musculaturaFacialOptions,
  handleCheckedField,
  masseterOptions,
  linguaMovimentacaoOptions,
  linguaAtrofiaOptions,
  veloPalatinoOptions,
}) {
  function handleSetData(value, field) {
    setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }
  return (
    <form autoComplete="off" onSubmit={onSubmit}>
      <Stack className="templateGridForm">
        <FieldSelect
          label="Reflexo fotomotor"
          value={data.reflexoFotomotor}
          setValue={(value) => handleSetData(value, "reflexoFotomotor")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Fundo de olho - Papiledema"
          value={data.papilederma}
          setValue={(value) => handleSetData(value, "papilederma")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Motricidade ocular - Oftalmoparesia"
          value={data.motricidadeOcular}
          setValue={(value) => handleSetData(value, "motricidadeOcular")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Ptose palpebral"
          value={data.ptosePalpebral}
          setValue={(value) => handleSetData(value, "ptosePalpebral")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Reflexo nauseoso"
          value={data.reflexoNauseoso}
          setValue={(value) => handleSetData(value, "reflexoNauseoso")}
          items={reflexoNauseosoOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack direction="row" className="labelText" mt={"24px"}>
        Musculatura facial
      </Stack>

      <Stack className="templateGridForm">
        <Stack
          className="templateGridFormCheckbox CheckboxColor"
          sx={{
            gridTemplateColumns: "repeat(auto-fit, minmax(250px,1fr ))",
            gridColumn: "span 2",
          }}
        >
          {musculaturaFacialOptions.map(({ key, value }) => {
            return (
              <FormControlLabel
                value={value}
                control={<Checkbox />}
                label={key}
                key={key}
                checked={data.musculaturaFacial?.includes(value)}
                onClick={(e) => handleCheckedField(e, "musculaturaFacial")}
              />
            );
          })}
        </Stack>
        <Stack sx={{ gridColumn: "span 2" }}></Stack>
      </Stack>

      <Stack direction="row" className="labelText">
        Masseter
      </Stack>

      <Stack className="templateGridForm">
        <Stack
          className="templateGridFormCheckbox"
          sx={{
            gridTemplateColumns: "repeat(auto-fit, minmax(250px,1fr ))",
            gridColumn: "span 2",
          }}
        >
          {masseterOptions.map(({ key, value }) => {
            return (
              <FormControlLabel
                value={value}
                control={<Radio />}
                label={key}
                key={key}
                checked={data.masseter === value}
                onChange={(e) => handleSetData(e.target.value, "masseter")}
              />
            );
          })}
        </Stack>
        <Stack sx={{ gridColumn: "span 2" }}></Stack>
      </Stack>

      <Stack direction="row" className="labelText" mb={"16px"}>
        Língua
      </Stack>

      <Stack
        className="templateGridForm"
        sx={{
          alignItems: "start",
        }}
      >
        <Stack>
          <Stack direction="row" className="labelText">
            Atrofia
          </Stack>
          <Stack className="templateGridFormCheckbox">
            {linguaAtrofiaOptions.map(({ key, value }) => {
              return (
                <FormControlLabel
                  value={value}
                  control={<Radio />}
                  label={key}
                  key={value}
                  checked={data.linguaAtrofia === value}
                  onChange={(e) =>
                    handleSetData(e.target.value, "linguaAtrofia")
                  }
                />
              );
            })}
          </Stack>
        </Stack>
        <Stack>
          <Stack direction="row" className="labelText">
            Movimentação
          </Stack>
          <Stack>
            {linguaMovimentacaoOptions.map(({ key, value }) => {
              return (
                <FormControlLabel
                  value={value}
                  control={<Radio />}
                  label={key}
                  key={value}
                  checked={data.linguaMovimentacao === value}
                  onChange={(e) =>
                    handleSetData(e.target.value, "linguaMovimentacao")
                  }
                />
              );
            })}
          </Stack>
        </Stack>
        <Stack>
          <Stack direction="row" className="labelText">
            Fasciculação
          </Stack>
          <Stack>
            {simOuNaoOptions.map(({ key, value }) => {
              return (
                <FormControlLabel
                  value={value}
                  control={<Radio />}
                  label={key}
                  key={value}
                  checked={data.linguaFasciculacao === value}
                  onChange={(e) =>
                    handleSetData(e.target.value, "linguaFasciculacao")
                  }
                />
              );
            })}
          </Stack>
        </Stack>

        <Stack></Stack>
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Velo palatino (Movimentação)"
          value={data.veloPalatino}
          setValue={(value) => handleSetData(value, "veloPalatino")}
          items={veloPalatinoOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        {[1, 2, 3].map((index) => (
          <Stack key={index}></Stack>
        ))}
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Disartria"
          value={data.disartria}
          setValue={(value) => handleSetData(value, "disartria")}
          items={simOuNaoOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Anartria"
          value={data.anartria}
          setValue={(value) => handleSetData(value, "anartria")}
          items={simOuNaoOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        {[1, 2].map((index) => (
          <Stack key={index}></Stack>
        ))}
      </Stack>

      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 3,
        }}
      >
        <Button className="buttonText cancel" variant="outlined">
          Cancelar
        </Button>
        <Button
          variant="contained"
          type="submit"
          name="nervosCranianos"
          className="buttonText submit"
        >
          Salvar
        </Button>
      </Stack>
    </form>
  );
}
